import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { entitySelectors } from '@store/entity/selectors';

import { SpaDaysV2 } from './SpaDaysV2';
import { SpaDaysV2DispatchProps, SpaDaysV2OwnProps, SpaDaysV2StoreProps } from './SpaDaysV2.types';

const mapStateToProps = (state): SpaDaysV2StoreProps => ({
  property: entitySelectors.getProperty(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = (dispatch): SpaDaysV2DispatchProps =>
  bindActionCreators({ changeJourneyParam }, dispatch);

export const SpaDaysV2Connected: React.ComponentType<SpaDaysV2OwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaDaysV2);
